export default function ({ $auth, store }, inject) {
  const msToLoad = 1e4;
  const bootIntercom = () => {
    if (process.client) {
      const expColor = store.getters['experience/getExperienceColor'];
      const experience = store.getters['experience/getExperience'] || 'default';
      window.intercomSettings = {
        app_id: process.env.INTERCOM_APP_ID,
        background_color: expColor,
        action_color: expColor,
        Experience: experience,
        Page: window.location.href
      };

      if ($auth.loggedIn) {
        window.intercomSettings.name = $auth.user.userName;
        window.intercomSettings.email = $auth.user.email;
        window.intercomSettings.avatar = {
          type: 'avatar',
          image_url: $auth.user.userAvatar
        };
        window.intercomSettings['User Id'] = $auth.user.idUser;
        window.intercomSettings['Plan Id'] = $auth.user.idPlan;
        window.intercomSettings['Plan Name'] = $auth.user.planName;
      }

      var w = window;
      var ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function () {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/' + process.env.INTERCOM_APP_ID;
          s.onload = updateUserInfoIntercom;
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        l();
      }
    }
  };

  setTimeout(bootIntercom, msToLoad);

  const setIntercomColor = () => {
    if (process.client && window.intercomSettings) {
      const expColor = store.getters['experience/getExperienceColor'];
      const experience = store.getters['experience/getExperience'] || 'default';
      window.intercomSettings.background_color = expColor;
      window.intercomSettings.action_color = expColor;
      window.intercomSettings.Experience = experience;
      let ic = window.Intercom;
      if (typeof ic === 'function') {
        ic('update', window.intercomSettings);
      }
    }
  };
  inject('setIntercomColor', setIntercomColor);

  const updateURLIntercom = () => {
    if (process.client) {
      let ic = window.Intercom;
      if (typeof ic === 'function') {
        window.intercomSettings.Page = window.location.href;
        ic('update', window.intercomSettings);
      }
    }
  };

  inject('updateURLIntercom', updateURLIntercom);

  const rebootIntercom = () => {
    if (process.client) {
      let ic = window.Intercom;
      if (typeof ic === 'function') {
        ic('shutdown');
        bootIntercom();
      }
    }
  };

  inject('rebootIntercom', rebootIntercom);

  const updateUserInfoIntercom = () => {
    if (process.client) {
      if ($auth.loggedIn) {
        let ic = window.Intercom;
        if (typeof ic === 'function') {
          window.intercomSettings.name = $auth.user.userName;
          window.intercomSettings.email = $auth.user.email;
          window.intercomSettings.avatar = {
            type: 'avatar',
            image_url: $auth.user.userAvatar
          };
          window.intercomSettings['User Id'] = $auth.user.idUser;
          window.intercomSettings['Plan Id'] = $auth.user.idPlan;
          window.intercomSettings['Plan Name'] = $auth.user.planName;
          ic('update', window.intercomSettings);
        }
      }
    }
  };

  inject('updateUserInfoIntercom', updateUserInfoIntercom);
}
